import { jsx as _jsx } from "react/jsx-runtime";
import { Link as HeroLink } from '@heroui/react';
export const Link = (props) => {
    return _jsx(HeroLink, { ...props });
};
export default Link;
//# sourceMappingURL=Link.js.map